import classnames from 'classnames';

import { FCWithChildren } from '../../interfaces/Shared';
import style from './Card.module.scss';

interface CardProps {
  className?: string;
}

const Card: FCWithChildren<CardProps> = ({ className, children }) => {
  const classes = classnames(style.container, className);

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default Card;
